import { filterErrorsByField } from 'Automations/automationEditor/utils'
import { Box, Grid } from '@sequencehq/core-components'
import { ConditionPropertyEditorComponent } from 'Automations/nodeDefinitions/conditions'
import { CustomerSelector } from '../../../switch/components/GroupEditor/inputs/components/CustomerSelector'
import { CustomerOperatorSelect } from './CustomerOperatorSelect'
import { appendTestId, readCustomerIds } from './CustomerPropertyEditor.helpers'

/**
 * Editor for the CUSTOMER.INCLUDES / CUSTOMER.EXCLUDES operators. Owns the
 * primary operator dropdown plus a customer multi-select; the stored value is
 * the selected customer ids (`string[]`).
 */
export const CustomerIncludesOperatorEditor: ConditionPropertyEditorComponent =
  ({
    'data-testid': dataTestId,
    operator,
    value,
    onChange,
    operators,
    siblingConditions,
    validationErrors
  }) => {
    return (
      <Grid
        gridTemplateColumns="2fr 3fr"
        gap="8px"
        gridTemplateAreas='"operator value"'
      >
        <Box gridArea="operator">
          <CustomerOperatorSelect
            data-testid={dataTestId}
            operator={operator}
            operators={operators}
            siblingConditions={siblingConditions}
            onChange={onChange}
            validationErrors={validationErrors?.operator}
          />
        </Box>
        <Box gridArea="value">
          <CustomerSelector
            multiple
            data-testid={appendTestId(dataTestId, 'value')}
            value={readCustomerIds(value)}
            onChange={next => onChange({ value: next })}
            validationErrors={filterErrorsByField(
              validationErrors?.value,
              'customerIds'
            )}
          />
        </Box>
      </Grid>
    )
  }
